import axios from "axios";
import { URL } from "../Home/api";

export const registerUser = async (data) => {
  try {
    await axios.post(`${URL}api/register/`, data);
    return { success: true };
  } catch (error) {
    const errorMessage = error.response?.data?.username?.[0] || error.message;
    return { success: false, message: errorMessage };
  }
};
